<div class="footer">
  <div class="left">
    <div class="price">
      <ng-container *ngIf="hostel && (currency | async) as c">
        {{hostel.minRate | currency: c.code}} / night
      </ng-container>
    </div>
    <a class="dates">
      <ng-container *ngIf="checkInDate && checkOutDate">
        {{ checkInDate | date : 'MMM d' }} - {{ checkOutDate | date : 'MMM d' }}
      </ng-container>
    </a>
  </div>
  <button class="btn btn-theme btn-large select-rooms" [routerLink]="['./rooms']" [queryParamsHandling]="'preserve'">
    <ng-container i18n>Select rooms</ng-container>
  </button>
</div>
